import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import SiteBlogItemComponent from "../../components/site/home/site-blog-item.component";
import SiteBuildCustomComponent from "../../components/site/home/site-build-custom.component";
import SiteCustomerSupportComponent from "../../components/site/home/site-customer-support.component";
import SiteFeaturesComponent from "../../components/site/home/site-features.component";
import SiteFindPlanComponent from "../../components/site/home/site-find-plan.component";
import SiteHumanClone from "../../components/site/home/site-human-clone.component";
import SiteSalesSupportComponent from "../../components/site/home/site-sales-support.component";
import SiteSocialNetworkComponent from "../../components/site/home/site-social-network.component";
import SiteSolutionIndustryComponent from "../../components/site/home/site-solution-industry.component";
import SiteTestemonialsComponent from "../../components/site/home/site-testemonials.component";
import SiteTrustedCustomersComponent from "../../components/site/home/site-trusted-customers.component";

const Home = () => {
  const { i18n, t } = useTranslation();
  return (
    <div className="home-page bg-eighteenColor">
      <SiteFindPlanComponent />
      <SiteTrustedCustomersComponent />
      <SiteFeaturesComponent />
      <SiteSalesSupportComponent />
      <SiteHumanClone />
      <SiteBuildCustomComponent />
      <SiteSolutionIndustryComponent />
      <SiteTestemonialsComponent />
      <Row className="my-5 mx-0  px-3 ">
        <Col className="p-0">
          <Row className="my-4">
            <Col className="text-center">
              <h1 className="font-sofiaSans fw-bold">
                {t("home/SiteBlogItem/title")}
              </h1>
            </Col>
          </Row>
          <Row className="md:tw-px-56">
            <SiteBlogItemComponent />
          </Row>
        </Col>
      </Row>
      <SiteCustomerSupportComponent />
      <SiteSocialNetworkComponent />
    </div>
  );
};

export default Home;
